import { Color4 } from './Color4';
import { Rect } from './Rect';
import { InterpolateCopyAction } from './InterpolateCopyAction';
import { Vector2 } from './Vector2';
import { InterpolateAction } from './InterpolateAction';
import { DiscreteAction } from './DiscreteAction';
import { DimensionSourceScale } from './DimensionSourceScale';
import { Size } from './Size';
import { HorizontalAlignment } from './HorizontalAlignment';
import { InterpolateInplaceAction } from './InterpolateInplaceAction';
import { lerp, lerpi } from './globalFunctions';
import { VerticalAlignment } from './VerticalAlignment';
import { DimensionSource } from './DimensionSource';
import { PropertyType } from './PropertyInfo';

export class ActionFactory {
  static CreateInterpolateDouble(): InterpolateCopyAction<number> {
    return new InterpolateCopyAction<number>().withInterpolateFunction(lerp);
  }

  static CreateInterpolateVector2(): InterpolateInplaceAction<Vector2> {
    return new InterpolateInplaceAction<Vector2>((v) => v.clone()).withInterpolateFunction(
      Vector2.lerpInplace
    );
  }

  static CreateInterpolateVector2Copy(): InterpolateCopyAction<Vector2> {
    return new InterpolateCopyAction<Vector2>().withInterpolateFunction(Vector2.lerp);
  }

  static CreateInterpolateInt(): InterpolateCopyAction<number> {
    return new InterpolateCopyAction<number>().withInterpolateFunction(lerpi);
  }

  static CreateInterpolate(type: PropertyType): InterpolateAction<any> | null {
    // TODO: check why we need PropertyType.Size here???
    if (type === PropertyType.Vector2 || type === PropertyType.Size) {
      return new InterpolateInplaceAction<Vector2>((v) => v.clone()).withInterpolateFunction(
        Vector2.lerpInplace
      );
    } else if (type === PropertyType.Int || type === PropertyType.Double) {
      return new InterpolateCopyAction<number>().withInterpolateFunction(lerp);
    } else if (type === PropertyType.Color4 || type === PropertyType.Color4i) {
      return new InterpolateInplaceAction<Color4>((v) => v.clone()).withInterpolateFunction(
        Color4.LerpInplace
      );
    }

    return null;
  }

  static CreateDiscrete(type: PropertyType): DiscreteAction<any> | null {
    if (type === PropertyType.Vector2) {
      return new DiscreteAction<Vector2>();
    }

    if (type === PropertyType.Int || type === PropertyType.Double) {
      return new DiscreteAction<number>();
    }

    if (type === PropertyType.Color4 || type === PropertyType.Color4i) {
      return new DiscreteAction<Color4>();
    }

    if (type === PropertyType.Bool) {
      return new DiscreteAction<boolean>();
    }

    if (type === PropertyType.Size) {
      return new DiscreteAction<Size>();
    }

    if (type === PropertyType.String) {
      return new DiscreteAction<string>();
    }

    if (type === PropertyType.HorizontalAlignment) {
      return new DiscreteAction<HorizontalAlignment>();
    }

    if (type === PropertyType.VerticalAlignment) {
      return new DiscreteAction<VerticalAlignment>();
    }

    if (type === PropertyType.DimensionSourceScale) {
      return new DiscreteAction<DimensionSourceScale>();
    }

    if (type === PropertyType.DimensionSource) {
      return new DiscreteAction<DimensionSource>();
    }

    if (type === PropertyType.Rect) {
      return new DiscreteAction<Rect>();
    }

    return null;
  }
}
